import React, { createContext, useMemo, useContext, useState, useEffect, useRef, useCallback } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import Cookies from 'universal-cookie';
import { useGeneral } from '../../Context/GeneralContext';
import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';

const HomeContext = createContext();

export function HomeProvider(props) {
    const {
        celda,
        confirm,
        setConfirm,
        confirmIni,
        setConfirmIni,
        confirmIniEsp,
        setConfirmIniEsp,
        confirmTermEsp,
        setConfirmTermEsp,
        tokenR,
        difCajas,
        modoCierre,
        scrapData,
        getStatusLinea,
    } = useGeneral();
    const [selectOrder, setSelectOrder] = useState('');
    const [connection, setConnection] = useState(null);
    const [orders, setOrders] = useState([]);
    const [ordersF, setOrdersF] = useState([]);
    const [parosEsp, setParosEsp] = useState([]);
    const [cant, setCant] = useState(0);
    const [isCorridaActive, setIsCorridaActive] = useState(0);
    const [porEfi, setPorEfi] = useState('');
    const [porUti, setPorUti] = useState('');
    const [mttr, setMttr] = useState('');
    const [mtbf, setMtbf] = useState('');
    const [intervalo, setIntervalo] = useState(0);
    const [startCorrida, setStartCorrida] = useState(false);
    const [auto, setAuto] = useState(false);
    const [IsLoadingTable, setIsLoadingTable] = useState(false);
    const [piezasB, setPiezasB] = useState('');
    const [piezasM, setPiezasM] = useState('');
    const [errorPb, setErrorPb] = useState(false);
    const [errorPm, setErrorPm] = useState(false);
    const [hErrorPm, setHErrorPm] = useState('');
    const [hErrorPb, setHErrorPb] = useState('');
    const [isSelectParoEsp, setIsSelectParoEsp] = useState(false);
    const [openP, setOpenP] = useState(false);
    const [count, setCount] = useState(false);
    const [selectParoEsp, setSelectParoEsp] = useState('');
    const [status, setStatus] = useState({ nombre: '...', codigo: 0 });
    const [selectParoEspNombre, setSelectParoEspNombre] = useState('');
    const [ordersN, setOrdersN] = useState([]);
    const [estatus, setEstatus] = useState([]);
    const [detailOrder, setDetailOrder] = useState({
        nombre: '',
        corrida: null,
        sku: '',
        fechaIni: '',
        fechaFin: '',
    });

    // Ref para acceder a estatus actualizado dentro de SignalR sin reiniciar la conexión
    const estatusRef = useRef([]);
    const lastSocketEstatusRef = useRef(null);
    useEffect(() => {
        estatusRef.current = estatus;
        if (lastSocketEstatusRef.current !== null) {
            const foundStatus = estatus.find(
                est => Number(est.codigo) === Number(lastSocketEstatusRef.current)
            );
            if (foundStatus) {
                setStatus(foundStatus);
            }
        }
    }, [estatus]);

    // Ref para acceder a isCorridaActive actualizado sin reiniciar callbacks
    const isCorridaActiveRef = useRef(isCorridaActive);
    useEffect(() => {
        isCorridaActiveRef.current = isCorridaActive;
    }, [isCorridaActive]);

    // Ref para getStatusLinea — evita que el efecto del hub se reinicie cada vez
    // que getStatusLinea cambia de referencia (sus deps cambian con celda/llamadas)
    const getStatusLineaRef = useRef(getStatusLinea);
    useEffect(() => {
        getStatusLineaRef.current = getStatusLinea;
    }, [getStatusLinea]);


    let intervalRef = useRef(null);
    let corridaActivaIntervalRef = useRef(null);
    const getCorridaActivaRef = useRef(null);
    const getCorridaRef = useRef(null);
    const getEstyContRef = useRef(null);
    const getOEETEEPRef = useRef(null);
    const [detailCorrida, setDetailCorrida] = useState({
        conteo: 0,
        corrida: 0,
        fechaFinReal: '',
        fechaIniReal: '',
        operador: '',
        piezasMalas: 0,
        producido: 0,
    });
    // Estado separado para guardar los metadatos de la corrida (Fechas, Ritmos) obtenidos por HTTP
    // Esto garantiza que el cálculo de "Planeado" use datos estáticos y no se vea afectado por SignalR
    const [runMetadata, setRunMetadata] = useState(null);

    const meses = useMemo(() => ([
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ]), []);

    const dias = useMemo(() => (['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado']), []);

    const getOrders = useCallback(async () => {
        const cookie = new Cookies();
        const linea = parseInt(cookie.get('linea'));
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/PisoOrdenes/GetOrdenes?linea=${linea}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenR.current}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const ordenes = await data.json();

        if (data.status !== 400) {
            if (ordenes !== 'Esta linea no tiene corridas activas o no existe.') {
                setOrders(ordenes);
                setOrdersF(ordenes);
            }
        }
    }, [tokenR]);

    const getCorrida = useCallback(async (idCorrida) => {
        const cookie = new Cookies();

        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE
            }/PisoOrdenes/GetCorrida?corrida=${idCorrida}&celda=${parseInt(cookie.get('celda'))}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenR.current}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const corrida = await data.json();

        if (data.status !== 400) {
            // Al seleccionar una corrida, mantener producido del web socket si ya existe
            setDetailCorrida(prev => {
                if (prev.producido > 0 && corrida[0]) {
                    return {
                        ...corrida[0],
                        producido: prev.producido, // Mantener el valor del web socket
                    };
                }
                return corrida[0];
            });
            setRunMetadata(corrida[0]); // Guardamos metadata estática
            if (startCorrida === false) {
                setStartCorrida(true);
            }

            orders.forEach((order) => {
                if (order.corrida === corrida[0].corrida) {
                    setDetailOrder(order);
                }
            });
        }
    }, [tokenR, startCorrida, orders]);

    const getEstyCont = useCallback(async (uToken) => {
        const cookie = new Cookies();
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Informes/GetConteoCorrida?celda=${parseInt(
                cookie.get('celda')
            )}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${uToken}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const values = await data.json();

        if (data.status !== 400) {
            // Solo actualizar cant si no hay cálculo dinámico activo
            // El cálculo dinámico se ejecuta cada segundo y no debe ser sobrescrito
            if (!runMetadata || !runMetadata.fechaIniReal || !runMetadata.ritmoIdeal) {
                setCant(values.planeado);
            }
            // El chip de estatus solo se actualiza desde HTTP si el web socket aún no ha enviado un valor
            if (lastSocketEstatusRef.current === null) {
                if (values.estatus < 0) {
                    setStatus({
                        categoria: 'EstatusCelda',
                        codigo: 0,
                        dValor: null,
                        descripcion: 'null',
                        nValor: null,
                        nombre: 'Paro Especial',
                        sValor: 'null',
                    });
                } else {
                    estatus.forEach((est) => {
                        if (Number(est.codigo) === Number(values.estatus)) {
                            setStatus(est);
                        }
                    });
                    if (values.estatus > 8) {
                        setStatus({
                            categoria: 'EstatusCelda',
                            codigo: 6,
                            dValor: null,
                            descripcion: 'null',
                            nValor: null,
                            nombre: 'Paro',
                            sValor: 'null',
                        });
                    }
                }
            }
        }
    }, [estatus, runMetadata]);
    const getOEETEEP = useCallback(async (uToken, esCorrida) => {
        // Si el cliente no muestra el gráfico de KPIs, no consultamos el servicio.
        if (process.env.REACT_APP_ALLOW_KPI_GRAPH !== 'true') return;
        const cookie = new Cookies();
        const offsetMinutos = new Date().getTimezoneOffset() * -1;
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Informes/GetOEETEEP?offsetMinutos=${offsetMinutos}&linea=${parseInt(
                cookie.get('linea')
            )}&celda=${parseInt(cookie.get('celda'))}&esCorrida=${esCorrida}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${uToken}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const values = await data.json();

        if (data.status !== 400) {
            setPorUti(Math.round(values.oee));
            setPorEfi(Math.round(values.teep));
            setMtbf(values.mtbf);
            setMttr(values.mttr);
        }
    }, []);


    const getCorridaActiva = useCallback(async () => {
        const cookie = new Cookies();
        const wasCorridaActive = isCorridaActiveRef.current;
        const currentSelectOrder = selectOrder;

        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE
            }/PisoOrdenes/GetCorridaActiva?linea=${parseInt(cookie.get('linea'))}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenR.current}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const corridaA = await data.json();
        if (data.status === 200) {
            setIsCorridaActive(true);
            isCorridaActiveRef.current = true;

            // Solo llamar servicios si realmente cambió el estado (no en cada llamada)
            if (!wasCorridaActive) {
                // Primera vez que se detecta corrida activa
                if (getOEETEEPRef.current) getOEETEEPRef.current(tokenR.current, intervalo === 0);
                // getEstyCont solo para actualizar estatus inicial, producido viene del web socket
                if (getEstyContRef.current && process.env.REACT_APP_ALLOW_REAL_COUNTS !== 'false') {
                    getEstyContRef.current(tokenR.current);
                }
                setSelectOrder(corridaA);
                if (getCorridaRef.current) getCorridaRef.current(corridaA);
            } else {
                // Si ya había corrida activa, solo actualizar selectOrder si cambió
                if (corridaA !== currentSelectOrder) {
                    setSelectOrder(corridaA);
                }
            }
        } else if (data.status === 400) {
            setIsCorridaActive(false);
            isCorridaActiveRef.current = false;
        }
    }, [tokenR, intervalo, selectOrder]);
    
    // Actualizar refs cuando cambien las funciones
    useEffect(() => {
        getCorridaActivaRef.current = getCorridaActiva;
        getCorridaRef.current = getCorrida;
        getEstyContRef.current = getEstyCont;
        getOEETEEPRef.current = getOEETEEP;
    }, [getCorridaActiva, getCorrida, getEstyCont, getOEETEEP]);

    const getCorridaIni = useCallback(async (idCorrida, uToken) => {
        const cookie = new Cookies();

        // let cell;
        // if (celda !== parseInt(cookie.get('celda')) && celda !== undefined) {
        //     cell = celda;
        // } else {
        //     cell = parseInt(cookie.get('celda'));
        // }
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE
            }/PisoOrdenes/GetCorrida?corrida=${idCorrida}&celda=${parseInt(cookie.get('celda'))}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${uToken}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const corrida = await data.json();
        if (data.status !== 400) {
            if (corrida.length > 0 && corrida[0].fechaFinReal === null) {
                const fOrden = orders.filter((order) => order.corrida === idCorrida);

                setOrdersF((ordersF) => {
                    const exists = ordersF.some(o => o.corrida === fOrden[0].corrida);
                    return exists ? ordersF : [...ordersF, fOrden[0]];
                });

                // Smart merge: el web socket es la fuente de verdad para producido y estatus
                // El servicio HTTP solo actualiza metadatos estáticos (fechas, operador, corrida, etc.)
                const socketHasSentStatus = lastSocketEstatusRef.current !== null;
                setDetailCorrida(prev => {
                    const hasDataChanged = (
                        corrida[0].fechaFinReal !== prev.fechaFinReal ||
                        corrida[0].conteo !== prev.conteo ||
                        corrida[0].piezasMalas !== prev.piezasMalas ||
                        corrida[0].operador !== prev.operador ||
                        corrida[0].corrida !== prev.corrida
                    );
                    if (hasDataChanged) {
                        return {
                            ...corrida[0],
                            // WebSocket es dueño de producido y estatus una vez conectado
                            producido: prev.producido,
                            estatus: socketHasSentStatus ? prev.estatus : corrida[0].estatus,
                        };
                    }
                    return prev;
                });

                // El chip de estatus solo se actualiza desde HTTP si el web socket aún no ha enviado un valor.
                // En clientes sin registro de paros el estatus se fija aparte (siempre "En operación").
                if (process.env.REACT_APP_ALLOW_PAROS_VIEW !== 'false' && !socketHasSentStatus && corrida[0].estatus !== undefined) {
                    const foundStat = (estatusRef.current || estatus).find(est => Number(est.codigo) === Number(corrida[0].estatus));
                    if (foundStat) setStatus(foundStat);
                }
                setRunMetadata(corrida[0]); // Guardamos metadata estática
                setSelectOrder(corrida[0].corrida);
                setStartCorrida(true);

                // Actualizar estatus inicialmente si viene en la corrida
                if (process.env.REACT_APP_ALLOW_PAROS_VIEW !== 'false' && corrida[0].estatus !== undefined) {
                    const foundStat = estatus.find(est => Number(est.codigo) === Number(corrida[0].estatus));
                    if (foundStat) setStatus(foundStat);
                }
            }
        } else {
            const fOrden = orders.filter((order) => order.corrida === idCorrida);

            if (fOrden[0].ordenProd !== null) {
                setOrdersF((ordersF) => [...ordersF, fOrden[0]]);
            }
            const nOrden = fOrden.filter((order) => order.corrida !== corrida[0].corrida);
            if (nOrden[0].ordenProd !== null) {
                setOrdersN((ordersN) => [...ordersN, nOrden[0]]);
            }
        }
    }, [orders, estatus]);

    const setCorrida = useCallback(async (starStopCorrida, status, method) => {
        const cookie = new Cookies();

        let res;
        let data;

        if ((process.env.REACT_APP_THEME === 'posTheme' || process.env.REACT_APP_THEME === 'novaTheme') && cookie.get('auto') === 'true') {
            let state;

            if (starStopCorrida === 'Iniciar') {
                state = 'IniciarCorrida';
                data = {
                    corrida: detailOrder.corrida,
                    linea: parseInt(cookie.get('linea')),
                    celda: parseInt(cookie.get('celda')),
                    operador: cookie.get('usuario'),
                };
            } else {
                state = 'FinalizarCorrida';
                if (modoCierre === 0) {
                    data = {
                        corrida: detailOrder.corrida,
                        linea: parseInt(cookie.get('linea')),
                    };
                } else if (modoCierre === 1) {
                    data = {
                        corrida: detailOrder.corrida,
                        linea: parseInt(cookie.get('linea')),
                        ...scrapData,
                    };
                } else {
                    data = {
                        corrida: detailOrder.corrida,
                        linea: parseInt(cookie.get('linea')),
                        diferenciaCajasUltimaTarima: difCajas,
                    };
                }
            }
            res = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Corridas/${state}`, {
                method: method,
                body: JSON.stringify(data),
                headers: {
                    authorization: `Bearer ${tokenR.current}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });
        } else {
            if (starStopCorrida === 'Iniciar') {
                data = {
                    corrida: detailOrder.corrida,
                    linea: parseInt(cookie.get('linea')),
                    operador: cookie.get('usuario'),
                    paquetesUltimaTarima: 0,
                };
                res = await fetch(
                    `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Corridas/IniciarCorrida`,
                    {
                        method: method,
                        body: JSON.stringify(data),
                        headers: {
                            authorization: `Bearer ${tokenR.current}`,
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    }
                );
            } else {
                if (process.env.REACT_APP_CIERRE_BUENAS_MALAS === 'true') {
                    // Cierre por piezas buenas/malas: las cantidades ya se enviaron vía
                    // AgregarPiezasPost/AjusteEsporadico; aquí solo se cierra la corrida.
                    data = {
                        corrida: detailOrder.corrida,
                        linea: parseInt(cookie.get('linea')),
                    };
                } else if (modoCierre === 1) {
                    data = {
                        corrida: detailOrder.corrida,
                        linea: parseInt(cookie.get('linea')),
                        ...scrapData,
                    };
                } else if (modoCierre === 2) {
                    data = {
                        corrida: detailOrder.corrida,
                        linea: parseInt(cookie.get('linea')),
                        diferenciaCajasUltimaTarima: difCajas,
                    };
                } else {
                    data = {
                        corrida: detailOrder.corrida,
                        linea: parseInt(cookie.get('linea')),
                    };
                }
                res = await fetch(
                    `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Corridas/FinalizarCorrida`,
                    {
                        method: method,
                        body: JSON.stringify(data),
                        headers: {
                            authorization: `Bearer ${tokenR.current}`,
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    }
                );
            }
        }

        if (res.status === 200) {
            if (status === true) {
                // setStatus('En ejecución');
                setStartCorrida(true);
                if (detailOrder?.corrida) {
                    getCorrida(detailOrder.corrida);
                }
            } else {
                clearInterval(intervalRef.current);
                setStartCorrida(false);
                setIsCorridaActive(false);
                isCorridaActiveRef.current = false;
                await sleep(2000);
                // setStatus('Pendiente');

                const dOrder = {
                    nombre: '',
                    corrida: null,
                    sku: '',
                    fechaIni: '',
                    fechaFin: '',
                };
                const dCorrida = {
                    conteo: 0,
                    corrida: 0,
                    fechaFinReal: '',
                    fechaIniReal: '',
                    operador: '',
                    piezasMalas: 0,
                    producido: 0,
                };

                setPiezasB('');
                setPiezasM('');
                setOrdersF([]);
                setOrdersN([]);
                setCant(0);
                setCant(0);
                setDetailOrder(dOrder);
                setDetailCorrida(dCorrida);
                setRunMetadata(null); // Limpiamos metadata
                setSelectOrder('');
                getOrders();
                getStatusLinea();
            }
        } else {
            console.error('error');
            console.error(res.status);
        }
    }, [
        detailOrder?.corrida,
        difCajas,
        getCorrida,
        getOrders,
        getStatusLinea,
        tokenR,
        modoCierre,
        scrapData,
    ]);

    function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    const ajusteEsp = useCallback(async () => {
        const cookie = new Cookies();
        const fechaA = new Date(Date.now());
        let ent = 0;
        if (cookie.get('auto') === 'false' || process.env.REACT_APP_CIERRE_BUENAS_MALAS === 'true') {
            ent = piezasB - parseInt(piezasM);
        } else {
            ent = detailCorrida?.producido ?? 0;
        }

        const traslado = {
            sku: detailOrder.sku,
            origen: 1,
            fechaHora: fechaA.toISOString(),
            destino: 1,
            tipo: 0,
            movimientos: [
                {
                    entrada: ent,
                    salida: 0,
                },
            ],
        };

        const res = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Movimientos/AjusteEsporadico`,
            {
                method: 'PUT',
                body: JSON.stringify(traslado),
                headers: {
                    authorization: `Bearer ${tokenR.current}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        if (res.status === 200) {
            setCorrida('Terminar', false, 'PUT');
        } else {
            console.error('error');
            console.error(res.status);
        }
    }, [detailOrder?.sku, tokenR, piezasB, piezasM, detailCorrida?.producido, setCorrida]);

    const piezaBpiezaM = useCallback(() => {
        const data = {
            corrida: detailOrder.corrida,
            cantPb: piezasB - parseInt(piezasM),
            cantPm: parseInt(piezasM),
        };
        const res = fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/PisoOrdenes/AgregarPiezasPost`,
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    authorization: `Bearer ${tokenR.current}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );
        res.then(async (respuesta) => {
            if (respuesta.status === 200) {
                ajusteEsp();
                // setCorrida('Terminar', false, 'PUT');
            } else {
                console.error('error');
                console.error(await respuesta.json(), respuesta.status);
            }
        });
    }, [tokenR, detailOrder.corrida, piezasB, piezasM, ajusteEsp]);

    const handleChangeOrder = (event) => {
        setSelectOrder(event.target.value);
    };

    const terminarCorrida = useCallback(() => {
        setErrorPm(false);
        setErrorPb(false);
        setHErrorPm('');
        setHErrorPb('');
        if (parseInt(piezasM) > parseInt(piezasB)) {
            setErrorPm(true);
            setHErrorPm(
                'La cantidad de pizas malas debe ser menor a la cantidad total de piezas creadas'
            );
        } else if (piezasB <= 0) {
            setErrorPb(true);
            setHErrorPb('El número ingresado debe ser mayor a cero');
        } else if (parseInt(piezasM) < 0 || piezasB <= 0) {
            setErrorPm(true);
            setHErrorPm('El número ingresado debe ser mayor a cero');
        } else {
            piezaBpiezaM();
            setOpenP(false);
        }
    }, [piezaBpiezaM, piezasB, piezasM]);

    const corrida = useCallback((state) => {
        const cookie = new Cookies();

        if (state === true) {
            const nOrden = ordersN.filter((order) => order.corrida !== detailOrder.corrida);
            setOrdersN(nOrden);
            const detCorrida = {
                conteo: 0,
                corrida: detailOrder.corrida,
                fechaFinReal: null,
                fechaIniReal: new Date(Date.now()).toISOString(),
                operador: cookie.get('usuario'),
                piezasMalas: 0,
                producido: 0,
            };

            setDetailCorrida(detCorrida);
            setCorrida('Iniciar', true, 'POST');
        } else {
            if (cookie.get('auto') === 'false') {
                setOpenP(true);
            } else {
                clearInterval(intervalRef.current);
                setCorrida('Terminar', false, 'PUT');
            }
        }
    }, [ordersN, detailOrder?.corrida, setCorrida, setDetailCorrida]);

    const handleCloseP = () => {
        setOpenP(false);
        setPiezasB('');
        setPiezasM('');
        setHErrorPb('');
        setHErrorPm('');
        // piezaBpiezaM();
    };

    // Abre directamente el modal "Conteo de Piezas" (buenas + malas) para terminar la
    // corrida, sin pasar por getUltimaEstiba/modoCierre. Usado por clientes con
    // REACT_APP_CIERRE_BUENAS_MALAS activo.
    const openCierrePiezas = () => {
        setErrorPb(false);
        setErrorPm(false);
        setHErrorPb('');
        setHErrorPm('');
        setPiezasB('');
        setPiezasM('');
        setOpenP(true);
    };

    const handlePiezasB = (e) => {
        setErrorPb(false);
        if (e.target.value < 0) {
            setErrorPb(true);
            setHErrorPb('El número ingresado debe ser mayor a cero');
        } else {
            setPiezasB(e.target.value);
            setHErrorPb('');
        }
    };

    const handlePiezasM = (e) => {
        setErrorPm(false);
        if (parseInt(e.target.value) < 0) {
            setErrorPm(true);
            setHErrorPm('El número ingresado debe ser mayor a cero');
        } else {
            setPiezasM(e.target.value);
            setHErrorPm('');
        }
    };




    const getEnum = useCallback(async () => {
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/MicroServiciosController?categoria=EstatusCelda`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenR.current}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const values = await data.json();

        if (data.status !== 400) {
            setEstatus(values);
        }
    }, [tokenR]);

    const getParosEsp = useCallback(async () => {
        const data = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Paros/GetCatParosAut`, {
            method: 'GET',
            headers: {
                authorization: `Bearer ${tokenR.current}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        });

        const values = await data.json();

        if (data.status !== 400) {
            setParosEsp(values);
        }
    }, [tokenR]);

    // Lógica para calcular el "Avance ideal" (Cant) en el cliente.
    // El backend no envía ritmoIdeal, así que lo derivamos del plan de la orden:
    //   ritmo ideal = meta / (fechaFin - fechaIni)  [piezas por unidad de tiempo]
    // y proyectamos el avance según el tiempo transcurrido desde el arranque real
    // de la corrida (fechaIniReal), topado en la meta.
    useEffect(() => {
        const calculatePlanned = () => {
            if (!runMetadata || !runMetadata.fechaIniReal) return;

            const ordenActual = orders?.find((o) => o.corrida === runMetadata.corrida);
            if (!ordenActual) return;

            const meta = Number(ordenActual.meta);
            const planStart = new Date(ordenActual.fechaIni).getTime();
            const planEnd = new Date(ordenActual.fechaFin).getTime();
            const plannedDurationMs = planEnd - planStart;

            // Necesitamos una meta y una duración planeada válidas
            if (!(meta > 0) || !(plannedDurationMs > 0)) return;

            // Ritmo ideal derivado del plan (piezas por ms)
            const idealRatePerMs = meta / plannedDurationMs;

            // Avance ideal según el tiempo transcurrido desde el arranque real
            const elapsedMs = Date.now() - new Date(runMetadata.fechaIniReal).getTime();

            let calculated = elapsedMs > 0 ? Math.floor(idealRatePerMs * elapsedMs) : 0;
            if (calculated > meta) calculated = meta;
            if (calculated < 0) calculated = 0;

            setCant(calculated);
        };

        calculatePlanned(); // Ejecutar inmediato
        const interval = setInterval(calculatePlanned, 30000); // Actualizar cada 30 s

        return () => clearInterval(interval);
    }, [runMetadata, runMetadata?.fechaIniReal, runMetadata?.corrida, orders]);

    // Clientes sin registro de paros: el chip de estatus no cambia de estado.
    // Si hay una corrida activa siempre muestra "En operación" (codigo 1).
    useEffect(() => {
        if (process.env.REACT_APP_ALLOW_PAROS_VIEW !== 'false') return;
        if (startCorrida || isCorridaActive) {
            const operativo =
                (estatusRef.current || []).find((e) => Number(e.codigo) === 1) || {
                    codigo: 1,
                    nombre: 'En operación',
                };
            setStatus(operativo);
        } else {
            setStatus({ nombre: '...', codigo: 0 });
        }
    }, [startCorrida, isCorridaActive, estatus]);

    useEffect(() => {
        const cookie = new Cookies();
        setAuto(cookie.get('auto') === 'true');
        setCount(cookie.get('count') === 'true');
        // Ejecutar servicios al montar con un pequeño delay para evitar llamadas simultáneas
        // Estos servicios son necesarios para inicializar la aplicación
        const initTimeout = setTimeout(() => {
            getOrders();
            getEnum();
            // El catálogo de paros automáticos solo aplica si el cliente usa ese selector.
            if (process.env.REACT_APP_ALLOW_SEL_PARO_AUT !== 'false') {
                getParosEsp();
            }
        }, 100); // Pequeño delay para espaciar las llamadas iniciales
        
        return () => clearTimeout(initTimeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Array vacío para ejecutar solo una vez al montar

    useEffect(() => {
        if (props.hubEnabled === false || process.env.REACT_APP_ALLOW_WEBSOCKETS === 'false') return;

        // const celdaId = parseInt(cookie.get('celda'));

        // Construir la URL del Hub basada en el endpoint de la API (evita hardcodeo para back externo)
        const apiBase = process.env.REACT_APP_SERVICE_ENDPOINT_NE || 'http://nova-engine.teseracto.com/api';
        const hubUrl = apiBase.replace('/api', '/HubNovaEngine');

        const newConnection = new HubConnectionBuilder()
            .withUrl(hubUrl, {
                skipNegotiation: true,
                transport: HttpTransportType.WebSockets,
            })
            .withAutomaticReconnect()
            .build();

        newConnection.onclose(() => { });
        newConnection.onreconnecting(() => { });
        newConnection.onreconnected(() => { });

        setConnection(newConnection);

        return () => {
            newConnection.stop();
            setConnection(null);
        };
    }, [props.hubEnabled]);

    const extractEstatus = useCallback((payload) => {
        if (!payload || typeof payload !== 'object') {
            return undefined;
        }
        const direct =
            payload.estatus ??
            payload.status ??
            payload.Estatus ??
            payload.EstatusCelda ??
            payload.estatusCelda ??
            payload.idEstatus ??
            payload.IdEstatus ??
            payload.estado ??
            payload.Estado ??
            payload.statusCode ??
            payload.StatusCode;
        if (direct !== undefined) {
            return direct;
        }
        const key = Object.keys(payload).find((k) => /estatus|status/i.test(k));
        return key ? payload[key] : undefined;
    }, []);

    useEffect(() => {
        if (connection) {
            // Best Practice: Registrar manejadores ANTES de iniciar la conexión
            const cookie = new Cookies();
            const celdaId = parseInt(cookie.get('celda'));

            const handleSignalRData = (data, source) => {
                if (data) {
                    unstable_batchedUpdates(() => {
                        let values = null;
                        // Normalizar data (objeto vs array)
                        if (Array.isArray(data) && data.length > 0) {
                            values = data[0];
                        } else if (!Array.isArray(data)) {
                            values = data;
                        }

                        // Detector de llaves resiliente (Soporta estatus, status, id, etc. y anidamiento en .data)
                        const actualValues = values?.data || values?.Data || values;
                        const detectedEstatus =
                            extractEstatus(actualValues) ??
                            extractEstatus(values);
                        
                        // El web socket envía PiezasProducidas en lugar de producido
                        const producidoFromSocket = actualValues?.PiezasProducidas ?? actualValues?.producido;
                        const conteoFromSocket = actualValues?.conteo ?? actualValues?.Conteo;
                        const piezasMalasFromSocket = actualValues?.piezasMalas ?? actualValues?.PiezasMalas;

                        if (actualValues) {
                            // Actualizar inmediatamente cuando llegue un mensaje del web socket
                            setDetailCorrida(prev => {
                                // Convertir a número para comparación correcta
                                const newProducido = producidoFromSocket !== undefined 
                                    ? Number(producidoFromSocket) 
                                    : prev.producido;
                                const newConteo = conteoFromSocket !== undefined 
                                    ? Number(conteoFromSocket) 
                                    : prev.conteo;
                                const newPiezasMalas = piezasMalasFromSocket !== undefined 
                                    ? Number(piezasMalasFromSocket) 
                                    : prev.piezasMalas;
                                const newEstatus = detectedEstatus !== undefined 
                                    ? Number(detectedEstatus) 
                                    : prev.estatus;

                                // Siempre actualizar si hay un valor nuevo
                                if (producidoFromSocket !== undefined || 
                                    conteoFromSocket !== undefined || 
                                    piezasMalasFromSocket !== undefined || 
                                    detectedEstatus !== undefined) {
                                    return {
                                        ...prev,
                                        producido: newProducido,
                                        piezasMalas: newPiezasMalas,
                                        conteo: newConteo,
                                        estatus: newEstatus,
                                    };
                                }
                                return prev;
                            });

                            // Actualización de Estatus Chip (SOLO si viene en el mensaje)
                            if (detectedEstatus !== undefined) {
                                const numericEstatus = Number(detectedEstatus);
                                lastSocketEstatusRef.current = numericEstatus;
                                getStatusLineaRef.current();
                                if (detectedEstatus < 0) {
                                    setStatus({
                                        categoria: 'EstatusCelda',
                                        codigo: 0,
                                        dValor: null,
                                        descripcion: 'null',
                                        nValor: null,
                                        nombre: 'Paro Especial',
                                        sValor: 'null',
                                    });
                                } else {
                                    const currentEstatus = estatusRef.current || [];
                                    const foundStatus = currentEstatus.find(est => Number(est.codigo) === numericEstatus);
                                    if (foundStatus) {
                                        setStatus(foundStatus);
                                    } else if (detectedEstatus > 8) {
                                        setStatus({
                                            categoria: 'EstatusCelda',
                                            codigo: 6,
                                            dValor: null,
                                            descripcion: 'null',
                                            nValor: null,
                                            nombre: 'Paro',
                                            sValor: 'null',
                                        });
                                    } else {
                                        setStatus({
                                            categoria: 'EstatusCelda',
                                            codigo: numericEstatus,
                                            dValor: null,
                                            descripcion: 'null',
                                            nValor: null,
                                            nombre: 'Actualizando...',
                                            sValor: 'null',
                                        });
                                    }
                                }
                            }
                        }
                    });
                }
            };

            // OFF antes de ON para evitar acumulación de handlers si el effect re-ejecuta
            const signalRHandler = (data) => handleSignalRData(data, 'RecibirDatosCelda');
            connection.off("RecibirDatosCelda");
            connection.on("RecibirDatosCelda", signalRHandler);

            connection.onreconnected(() => {
                connection.invoke("SuscribirseACelda", celdaId.toString()).catch(() => {});
            });

            let aborted = false;

            connection
                .start()
                .then(() => {
                    if (aborted) { connection.stop(); return; }
                    connection.invoke("SuscribirseACelda", celdaId.toString())
                        .then(() => { })
                        .catch(() => { });
                })
                .catch(() => { });

            return () => {
                aborted = true;
                connection.off("RecibirDatosCelda", signalRHandler);
                connection.stop();
            };
        }
    }, [connection, extractEstatus]);

    const insertParoEsp = useCallback(async () => {
        const cookie = new Cookies();
        const current = new Date();
        const nextYear = new Date();
        nextYear.setFullYear(current.getFullYear() + 1);
        const data = {
            linea: parseInt(cookie.get('linea')),
            codigo: selectParoEsp,
        };
        cookie.set('ParoEspecial', selectParoEsp, { path: '/', expires: nextYear });

        cookie.set('ParoEspecialNombre', selectParoEspNombre, { path: '/', expires: nextYear });
        const res = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Estatus/iniciarParoAutorizado`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        });
        if (res.status === 200) {
            // cookie.set('ParoEspecial', selectParoEsp, {
            //     path: '/',
            //     domain: 'postobon.nova-mes.com',
            //     expires: nextYear,
            // });
            // cookie.set('ParoEspecialNombre', selectParoEspNombre, {
            //     path: '/',
            //     domain: 'postobon.nova-mes.com',
            //     expires: nextYear,
            // });
        } else {
            console.error('error');
            console.error(res.status);
        }
    }, [selectParoEsp, selectParoEspNombre]);

    const stopParoEsp = async () => {
        const cookie = new Cookies();
        const data = {
            linea: parseInt(cookie.get('linea')),
        };
        cookie.remove('ParoEspecial', { path: '/' });
        cookie.remove('ParoEspecialNombre', { path: '/' });
        const res = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Estatus/terminarParoAutorizado`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        });
        if (res.status === 200) {
            setSelectParoEsp('');
            // cookie.remove('ParoEspecial', { path: '/', domain: 'postobon.nova-mes.com' });
            // cookie.remove('ParoEspecialNombre', { path: '/', domain: 'postobon.nova-mes.com' });
            // console.log('Cookies borradas');
        } else {
            console.error('error');
            console.error(res.status);
        }
    };

    useEffect(() => {
        if (selectOrder !== '') {
            const orden = orders.filter((order) => order.corrida === selectOrder);
            setDetailOrder(orden[0]);
        }
    }, [orders, selectOrder]);

    useEffect(() => {
        if (confirm === true) {
            corrida(false);
            setConfirm(false);
        }
    }, [confirm, corrida, setConfirm]);

    useEffect(() => {
        if (confirmIni === true) {
            corrida(true);
            setConfirmIni(false);
        }
    }, [confirmIni, corrida, setConfirmIni]);

    useEffect(() => {
        if (confirmIniEsp === true) {
            insertParoEsp(selectParoEsp);
            setConfirmIniEsp(false);
        }
    }, [confirmIniEsp, insertParoEsp, selectParoEsp, setConfirmIniEsp]);

    useEffect(() => {
        if (confirmTermEsp === true) {
            stopParoEsp(selectParoEsp);
            setIsSelectParoEsp(false);
            setConfirmTermEsp(false);
        }
    }, [confirmTermEsp, selectParoEsp, setConfirmTermEsp]);


    useEffect(() => {
        if (startCorrida === true) {
            intervalRef.current = setInterval(() => {
                if (tokenR.current !== undefined) {
                    // Solo actualizar otros campos (no producido, viene del web socket)
                    getCorridaIni(detailCorrida?.corrida, tokenR.current);
                    // getEstyCont solo para actualizar estatus del chip, no producido (viene del web socket)
                    // Reducir frecuencia a 30 segundos ya que el estatus también puede venir del web socket
                }
            }, 30000); // Aumentado a 30 segundos - producido viene del web socket en tiempo real
        }
        return () => {
            clearInterval(intervalRef.current);
        };
    }, [startCorrida, celda, intervalo, tokenR, getCorridaIni, detailCorrida?.corrida]);


    // Usar intervalo para getCorridaActiva en lugar de ejecutarlo cada vez que cambia
    const ordersInitializedRef = useRef(false);
    useEffect(() => {
        if (orders.length > 0 && !ordersInitializedRef.current) {
            ordersInitializedRef.current = true;
            // Llamar inmediatamente solo la primera vez que orders se carga
            // Usar un delay mayor para evitar llamadas simultáneas con otros servicios al inicio
            const timeoutId = setTimeout(() => {
                if (getCorridaActivaRef.current) {
                    getCorridaActivaRef.current();
                }
            }, 1000); // Aumentado a 1 segundo para espaciar mejor las llamadas al inicio
            
            // Luego configurar intervalo de 30 segundos (reducido de 15 seg)
            // El web socket actualiza producido en tiempo real, así que no necesitamos verificar tan seguido
            corridaActivaIntervalRef.current = setInterval(() => {
                if (getCorridaActivaRef.current) {
                    getCorridaActivaRef.current();
                }
            }, 30000); // 30 segundos - suficiente para detectar cambios de corrida activa
            
            return () => {
                clearTimeout(timeoutId);
                if (corridaActivaIntervalRef.current) {
                    clearInterval(corridaActivaIntervalRef.current);
                }
            };
        } else if (orders.length === 0) {
            // Resetear el flag si orders se vacía
            ordersInitializedRef.current = false;
            if (corridaActivaIntervalRef.current) {
                clearInterval(corridaActivaIntervalRef.current);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orders.length]); // Solo depender de orders.length, getCorridaActiva está en el ref

    // Re-fetch inmediato de KPIs cuando el usuario cambia el selector Corrida/Acumulado día
    useEffect(() => {
        if (startCorrida && tokenR.current) {
            if (getOEETEEPRef.current) getOEETEEPRef.current(tokenR.current, intervalo === 0);
        }
    }, [intervalo, startCorrida, tokenR]);

    // Polling de KPIs cada 10 segundos mientras hay corrida activa
    useEffect(() => {
        if (!startCorrida || !tokenR.current || process.env.REACT_APP_ALLOW_KPI_GRAPH !== 'true') return;

        const interval = setInterval(() => {
            if (getOEETEEPRef.current) getOEETEEPRef.current(tokenR.current, intervalo === 0);
        }, 10000);

        return () => clearInterval(interval);
    }, [startCorrida, tokenR, intervalo]);

    const homeValues = useMemo(() => {
        return {
            selectOrder,
            handleChangeOrder,
            orders,
            meses,
            detailOrder,
            setDetailOrder,
            dias,
            startCorrida,
            setStartCorrida,
            corrida,
            cant,
            setCant,
            auto,
            count,
            detailCorrida,
            status,
            setStatus,
            handleCloseP,
            openCierrePiezas,
            openP,
            handlePiezasB,
            handlePiezasM,
            piezasM,
            setPiezasM,
            piezasB,
            setPiezasB,
            errorPb,
            errorPm,
            terminarCorrida,
            hErrorPm,
            hErrorPb,
            ordersF,
            ordersN,
            setOrdersN,
            getOrders,
            isCorridaActive,
            porUti,
            setPorUti,
            porEfi,
            setPorEfi,
            mttr,
            mtbf,
            intervalo,
            setIntervalo,
            IsLoadingTable,
            setIsLoadingTable,
            parosEsp,
            setParosEsp,
            insertParoEsp,
            selectParoEsp,
            setSelectParoEsp,
            stopParoEsp,
            setSelectParoEspNombre,
            isSelectParoEsp,
            setIsSelectParoEsp,
        };
    }, [selectOrder, orders, meses, detailOrder, dias, startCorrida, corrida, cant, auto, count, detailCorrida, status, openP, piezasM, piezasB, errorPb, errorPm, terminarCorrida, hErrorPm, hErrorPb, ordersF, ordersN, getOrders, isCorridaActive, porUti, porEfi, mttr, mtbf, intervalo, IsLoadingTable, parosEsp, insertParoEsp, selectParoEsp, isSelectParoEsp]);

    return <HomeContext.Provider value={homeValues} {...props} />;
}

export function useHome() {
    const context = useContext(HomeContext);
    if (!context) {
        throw new Error('useHome debe estar dentro del proveedor HomeContext');
    }
    return context;
}
